import React from "react";

const GameArenaCard = ({ id, idx, accentColor, label, content }) => {
  return (
    <div
      key={id}
      className={`arena-card arena-card--${idx} arena-card--back`}
      style={{ "--card-accent": accentColor }}
    >
      <div className="arena-card-hidden-content">
        {content}
      </div>
      <div className="arena-card-peek-label">{label}</div>
    </div>
  );
};

export default GameArenaCard;
